import { Form } from "antd";
import TripSelection from "../TripTypeSelect/TripTypeSelect";

export default function TripSelectionComponent() {
  return (
    <Form.Item className="m-0! w-full md:w-min" name="journeyType">
      <TripSelection />
    </Form.Item>
  );
}
